export default __webpack_public_path__ + "static/media/bra-arte-12.dee50e59.webp";